import React from "react";
import { useRouteNode } from "../router/Route";
function EmptyRoute() {
  var route = useRouteNode();
  return null;
}
export {
  EmptyRoute
};
//# sourceMappingURL=EmptyRoute.js.map
